export default __webpack_public_path__ + "static/media/industry.5046e69b.jpg";